export const USER_ROLES = {
  dory: 'dory',
  pharmacy: 'pharmacy',
  user: 'user',
}
